var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailSent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.72,374.39c83.79,43.77,219.63,43.77,303.41,0s83.79-114.74,0-158.51-219.63-43.77-303.41,0S6.93,330.62,90.72,374.39Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.83,315.13c-19.71,11.37-19.71,29.82,0,41.2s51.65,11.38,71.36,0,19.7-29.83,0-41.2S311.53,303.75,291.83,315.13Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-planes--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "84.31 152.03 137.11 135.61 96.49 163.75 84.31 152.03",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.11 135.61 80.24 144.99 68.06 133.26 137.11 135.61",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.24 144.99 80.24 159.06 84.31 152.03 137.11 135.61 80.24 144.99",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.24 159.06 88.37 155.94 84.31 152.03 80.24 159.06",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.31 152.03 88.37 155.94 87.07 156.43 84.31 152.03",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.49,156.94a.75.75,0,0,1-.37-1.41c.9-.5,1.81-1,2.71-1.39a.75.75,0,1,1,.65,1.35c-.87.42-1.76.87-2.63,1.36A.8.8,0,0,1,71.49,156.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.26,237.7a.75.75,0,0,1-.43-.13,41,41,0,0,1-4.61-3.78.75.75,0,1,1,1-1.09,39,39,0,0,0,4.45,3.64.75.75,0,0,1-.44,1.36Zm-7.84-7.28a.74.74,0,0,1-.58-.27,40.94,40.94,0,0,1-3.43-4.87.75.75,0,0,1,1.29-.78,40,40,0,0,0,3.3,4.7.75.75,0,0,1-.1,1.05A.72.72,0,0,1,54.42,230.42Zm-5.63-9.1a.75.75,0,0,1-.69-.44A46.93,46.93,0,0,1,46,215.31a.75.75,0,0,1,1.43-.44,45.67,45.67,0,0,0,2,5.39.75.75,0,0,1-.37,1A.7.7,0,0,1,48.79,221.32Zm-3.25-10.21a.75.75,0,0,1-.73-.61,52,52,0,0,1-.81-5.88.75.75,0,1,1,1.5-.12,48.72,48.72,0,0,0,.78,5.71.74.74,0,0,1-.59.88Zm-.95-10.68h0a.74.74,0,0,1-.74-.76,53.34,53.34,0,0,1,.4-5.92.75.75,0,1,1,1.48.18,53,53,0,0,0-.38,5.76A.75.75,0,0,1,44.59,200.43Zm1.22-10.65a.5.5,0,0,1-.17,0,.75.75,0,0,1-.57-.89,46.76,46.76,0,0,1,1.68-5.71.75.75,0,0,1,1-.45.76.76,0,0,1,.45,1,45.4,45.4,0,0,0-1.62,5.52A.75.75,0,0,1,45.81,189.78Zm3.56-10.1a.62.62,0,0,1-.33-.08.74.74,0,0,1-.35-1,48.28,48.28,0,0,1,2.94-5.17.75.75,0,0,1,1-.21.74.74,0,0,1,.22,1,45.35,45.35,0,0,0-2.85,5A.74.74,0,0,1,49.37,179.68Zm5.75-9a.72.72,0,0,1-.46-.16.75.75,0,0,1-.12-1.06,53,53,0,0,1,4-4.41.75.75,0,0,1,1.06,0,.75.75,0,0,1,0,1.06,53.57,53.57,0,0,0-3.86,4.29A.74.74,0,0,1,55.12,170.64ZM62.64,163a.74.74,0,0,1-.57-.27.76.76,0,0,1,.09-1.06,58.76,58.76,0,0,1,4.75-3.56.75.75,0,0,1,1,.2.76.76,0,0,1-.2,1.05,55.83,55.83,0,0,0-4.63,3.47A.78.78,0,0,1,62.64,163Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.14,241.61a.7.7,0,0,1-.31-.07c-.93-.42-1.85-.87-2.73-1.35a.74.74,0,0,1-.31-1,.75.75,0,0,1,1-.31c.86.46,1.75.9,2.65,1.31a.75.75,0,0,1-.31,1.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.19 205.32 453.49 178.24 472.12 184.22 411.19 205.32",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.19 205.32 447.75 174.84 439.62 165.46 411.19 205.32",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.75 174.84 447.75 181.91 411.19 205.32 447.75 174.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,171.89a.72.72,0,0,1-.49-.19.76.76,0,0,1-.07-1.06,29.63,29.63,0,0,0,3.45-4.71.75.75,0,0,1,1.3.76,32.37,32.37,0,0,1-3.62,4.95A.75.75,0,0,1,456,171.89Zm5.72-9.32a.86.86,0,0,1-.27,0,.75.75,0,0,1-.42-1,30.36,30.36,0,0,0,1.58-5.63.75.75,0,0,1,1.48.27,32.32,32.32,0,0,1-1.67,5.9A.74.74,0,0,1,461.72,162.57Zm2.14-10.73h0a.74.74,0,0,1-.73-.76c0-.26,0-.52,0-.78a33.41,33.41,0,0,0-.4-5.07.76.76,0,0,1,.63-.86.77.77,0,0,1,.86.63,35.14,35.14,0,0,1,.41,5.3c0,.27,0,.54,0,.81A.76.76,0,0,1,463.86,151.84ZM462.35,141a.74.74,0,0,1-.71-.54,37.83,37.83,0,0,0-2.15-5.47.74.74,0,0,1,.35-1,.75.75,0,0,1,1,.35,38.12,38.12,0,0,1,2.23,5.69.74.74,0,0,1-.5.93A.57.57,0,0,1,462.35,141Zm-4.64-9.93a.73.73,0,0,1-.63-.35,44.8,44.8,0,0,0-3.53-4.71.75.75,0,0,1,.08-1.06.74.74,0,0,1,1.05.08,45.65,45.65,0,0,1,3.66,4.88.77.77,0,0,1-.22,1A.78.78,0,0,1,457.71,131.06Zm-7-8.41a.73.73,0,0,1-.51-.21,54.48,54.48,0,0,0-4.53-3.8.75.75,0,1,1,.9-1.2,54.1,54.1,0,0,1,4.66,3.91.75.75,0,0,1-.52,1.3ZM441.94,116a.75.75,0,0,1-.4-.12c-.68-.42-1.39-.84-2.11-1.25-1-.56-2-1.12-3.06-1.65a.75.75,0,1,1,.68-1.33c1.05.54,2.1,1.1,3.12,1.68.74.41,1.46.84,2.16,1.28a.75.75,0,0,1,.25,1A.77.77,0,0,1,441.94,116Zm-89.65-.51a.76.76,0,0,1-.65-.38.74.74,0,0,1,.27-1c1.74-1,3.53-2,5.34-2.84a.75.75,0,0,1,1,.34.76.76,0,0,1-.35,1c-1.78.87-3.54,1.8-5.25,2.79A.71.71,0,0,1,352.29,115.47Zm79.9-4.57a.66.66,0,0,1-.3-.07c-1.8-.79-3.66-1.53-5.52-2.19a.75.75,0,0,1,.51-1.42c1.89.68,3.78,1.43,5.62,2.24a.75.75,0,0,1-.31,1.44Zm-70.05-.31a.74.74,0,0,1-.69-.46.75.75,0,0,1,.4-1c1.85-.78,3.75-1.5,5.65-2.15a.75.75,0,0,1,1,.46.77.77,0,0,1-.47,1c-1.87.64-3.75,1.35-5.56,2.11A.79.79,0,0,1,362.14,110.59Zm59.73-3.46a.76.76,0,0,1-.21,0c-1.89-.55-3.83-1-5.76-1.47a.75.75,0,0,1,.32-1.47c2,.43,3.94.94,5.86,1.5a.75.75,0,0,1-.21,1.47ZM372.52,107a.75.75,0,0,1-.72-.55.74.74,0,0,1,.51-.92c1.93-.54,3.91-1,5.88-1.44a.75.75,0,1,1,.31,1.46c-1.94.41-3.88.89-5.78,1.42Zm38.63-2.26H411c-1.95-.31-3.94-.56-5.9-.74a.75.75,0,1,1,.13-1.49c2,.18,4,.43,6,.75a.76.76,0,0,1,.62.86A.75.75,0,0,1,411.15,104.71Zm-27.89-.07a.75.75,0,0,1-.74-.63.76.76,0,0,1,.63-.86c2-.3,4-.55,6-.72a.75.75,0,1,1,.13,1.5c-2,.17-3.95.4-5.9.71Zm16.95-1h0c-2-.07-4-.08-5.95,0a.73.73,0,0,1-.77-.72.74.74,0,0,1,.73-.77c2-.07,4-.06,6,0a.75.75,0,0,1,.73.77A.76.76,0,0,1,400.21,103.65Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mailbox--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.44,219.94v-1.6h-.39a6.26,6.26,0,0,0-2.59-2.54,15.93,15.93,0,0,0-14.42,0,6.26,6.26,0,0,0-2.59,2.54h-.39v1.55c0,1.53,1,3.07,3,4.24a16,16,0,0,0,14.42,0C395.46,223,396.45,221.46,396.44,219.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 386.25,
    cy: 218.34,
    rx: 10.19,
    ry: 5.89,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.63,169.3v48.35a1.31,1.31,0,0,0,.76,1.07,4.11,4.11,0,0,0,3.71,0,1.3,1.3,0,0,0,.77-1.07V169.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,133.11c-2.55-1.47-4.87-1.59-6.61-.62h0L359,151.21l16.25,32.59,32.5-18.8V150.74C407.75,144.11,403.38,136.22,398,133.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.25,169.53V183.8l-19.49-11.26V158.28c0-6.63,4.36-9.48,9.74-6.37,3.45,2,6.48,5.94,8.21,10.26A20.27,20.27,0,0,1,375.25,169.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.25,169.53V183.8l-19.49-11.26,17.95-10.37A20.27,20.27,0,0,1,375.25,169.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,174.42c-1.79-5.18-7.61-11.9-13-15s-8.29-1.43-6.5,3.75l3.25,9.38,19.5,11.26S373.8,179.6,372,174.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.41,170.07l-1.09-.63h0a1.46,1.46,0,0,0-1.46.14,4.59,4.59,0,0,0-2.07,3.59,1.45,1.45,0,0,0,.61,1.34h0l1,.58.19-.31a2,2,0,0,0,.59-.23,4.57,4.57,0,0,0,2.07-3.58,2.13,2.13,0,0,0-.07-.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.9,170.19a4.57,4.57,0,0,0-2.07,3.58c0,1.32.93,1.85,2.07,1.19a4.56,4.56,0,0,0,2.07-3.58C386,170.06,385,169.53,383.9,170.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.9,173.14a.6.6,0,0,1-.6-.6V151.91a.6.6,0,0,1,1.2,0v20.63A.6.6,0,0,1,383.9,173.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.44 152.45 384.44 157.83 390.21 151.91 384.44 152.45",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.08,330.91c-.5.27-9.68,2.87-13.08-1.62s2.25-11.49-.94-14.07-12.13,0-14.28-5.42,4.22-7.76.64-13.23c-2.26-3.45-8.58-5.35-8.29-8.56.42-4.69,9.06-6,16.6-.93s11.06.91,13.45.57,7.55.41,7.39,8.81S81.08,330.91,81.08,330.91Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.69,319a.51.51,0,0,1-.5-.42c-2.63-16-21.16-28.93-30.8-31.71a.49.49,0,0,1-.34-.62.5.5,0,0,1,.62-.34c9.85,2.85,28.81,16.14,31.51,32.51a.5.5,0,0,1-.41.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.83,305.61a.5.5,0,0,1-.26-.93c.3-.18,7.44-4.35,14.46-2.4a.5.5,0,0,1-.26,1c-6.62-1.84-13.62,2.25-13.69,2.29A.45.45,0,0,1,59.83,305.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5,246.42c3.94.54,10.65-1.74,11.13-8.3s3.19-8.34,8.16-9.41,6.43-2.8,7-5.92-3.21-6.85-2.15-11.55,4.6-4.69,8.08-10c2.23-3.42-2.34-8.64-9.95-6.4s-7,7.15-14.61,7.78-12.38,5.25-12.53,11S342.5,246.42,342.5,246.42Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5,246.42c3.94.54,10.65-1.74,11.13-8.3s3.19-8.34,8.16-9.41,6.43-2.8,7-5.92-3.21-6.85-2.15-11.55,4.6-4.69,8.08-10c2.23-3.42-2.34-8.64-9.95-6.4s-7,7.15-14.61,7.78-12.38,5.25-12.53,11S342.5,246.42,342.5,246.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.06,233.84H341a.5.5,0,0,1-.39-.59c3.68-18.19,23.75-34.84,28.64-36.54a.5.5,0,0,1,.33,1c-4.78,1.66-24.39,18-28,35.79A.51.51,0,0,1,341.06,233.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelopes--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.88,227.39a5.74,5.74,0,0,1,2.6-4.5l132.91-76.74a5.78,5.78,0,0,1,5.19,0l2.93,1.7a5.71,5.71,0,0,1,2.6,4.5V254.23a5.77,5.77,0,0,1-2.6,4.5L87.6,335.46a5.74,5.74,0,0,1-5.2,0l-2.92-1.69a5.76,5.76,0,0,1-2.6-4.5Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.88,227.39a5.74,5.74,0,0,1,2.6-4.5l132.91-76.74a5.78,5.78,0,0,1,5.19,0l2.93,1.7a5.71,5.71,0,0,1,2.6,4.5V254.23a5.77,5.77,0,0,1-2.6,4.5L87.6,335.46a5.74,5.74,0,0,1-5.2,0l-2.92-1.69a5.76,5.76,0,0,1-2.6-4.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.06,231.43l-11.42-6.6a5.32,5.32,0,0,0-.76,2.56V329.27a5.76,5.76,0,0,0,2.6,4.5l2.92,1.69a5.74,5.74,0,0,0,5.2,0l1.46-.84Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.06,231.43l-11.42-6.6a5.32,5.32,0,0,0-.76,2.56V329.27a5.76,5.76,0,0,0,2.6,4.5l2.92,1.69a5.74,5.74,0,0,0,5.2,0l1.46-.84Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.11,152.35V254.23a5.3,5.3,0,0,1-.81,2.63,5.57,5.57,0,0,1-1.52,1.7l-.1.06-.17.11L87.6,335.46h0a1.85,1.85,0,0,1-1.77.2A1.79,1.79,0,0,1,85,334V232.08a2.26,2.26,0,0,1,2.92-2.3l55.89,13.29,7.32,1.74a4.82,4.82,0,0,0,4.67-1.75l8.48-11.81,57.08-79.47C222.32,150.44,223.11,150.69,223.11,152.35Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.11,152.35V254.23a5.3,5.3,0,0,1-.81,2.63,5.57,5.57,0,0,1-1.52,1.7l-.1.06-.17.11L87.6,335.46h0a1.85,1.85,0,0,1-1.77.2A1.79,1.79,0,0,1,85,334V232.08a2.26,2.26,0,0,1,2.92-2.3l55.89,13.29,7.32,1.74a4.82,4.82,0,0,0,4.67-1.75l8.48-11.81,57.08-79.47C222.32,150.44,223.11,150.69,223.11,152.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.51,258.73l.17-.11.1-.06a5.57,5.57,0,0,0,1.52-1.7,5.27,5.27,0,0,0,.81-2.59l-58.83-23,39.4,37.2Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.51,258.73l.17-.11.1-.06a5.57,5.57,0,0,0,1.52-1.7,5.27,5.27,0,0,0,.81-2.59l-58.83-23,39.4,37.2Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,334a1.79,1.79,0,0,0,.81,1.71,1.85,1.85,0,0,0,1.77-.2h0L133.36,309l10.45-66L85,332.27Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,334a1.79,1.79,0,0,0,.81,1.71,1.85,1.85,0,0,0,1.77-.2h0L133.36,309l10.45-66L85,332.27Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,256.86a5.57,5.57,0,0,1-1.52,1.7l-.1.06L87.6,335.46h0a1.85,1.85,0,0,1-1.77.2l63.65-101.61A10,10,0,0,1,162,230.23Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,256.86a5.57,5.57,0,0,1-1.52,1.7l-.1.06L87.6,335.46h0a1.85,1.85,0,0,1-1.77.2l63.65-101.61A10,10,0,0,1,162,230.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,229.08l61.13,27a10,10,0,0,0,12.52-3.85L222.84,149.5Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,229.08l61.13,27a10,10,0,0,0,12.52-3.85L222.84,149.5Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,229.08l61.56,23a10,10,0,0,0,11.87-3.9l64.41-98.68Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,229.08l61.56,23a10,10,0,0,0,11.87-3.9l64.41-98.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.58,239.94a5.71,5.71,0,0,1,2.6-4.5L235.09,158.7a5.74,5.74,0,0,1,5.2,0l2.93,1.69a5.74,5.74,0,0,1,2.59,4.5V266.77a5.76,5.76,0,0,1-2.59,4.5L110.3,348a5.78,5.78,0,0,1-5.19,0l-2.93-1.69a5.77,5.77,0,0,1-2.6-4.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.58,239.94a5.71,5.71,0,0,1,2.6-4.5L235.09,158.7a5.74,5.74,0,0,1,5.2,0l2.93,1.69a5.74,5.74,0,0,1,2.59,4.5V266.77a5.76,5.76,0,0,1-2.59,4.5L110.3,348a5.78,5.78,0,0,1-5.19,0l-2.93-1.69a5.77,5.77,0,0,1-2.6-4.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.77,244l-11.43-6.59a5.29,5.29,0,0,0-.76,2.56V341.82a5.77,5.77,0,0,0,2.6,4.5l2.93,1.69a5.78,5.78,0,0,0,5.19,0l1.47-.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.82,164.89V266.77a5.3,5.3,0,0,1-.81,2.63,5.57,5.57,0,0,1-1.52,1.7l-.1.06-.17.11L110.31,348h0a1.85,1.85,0,0,1-1.77.2,1.79,1.79,0,0,1-.81-1.71V244.62a2.26,2.26,0,0,1,2.92-2.3l55.89,13.29,7.32,1.74a4.82,4.82,0,0,0,4.67-1.75L187,243.79l57.08-79.47C245,163,245.82,163.23,245.82,164.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.22,271.27l.17-.11.1-.06a5.57,5.57,0,0,0,1.52-1.7,5.29,5.29,0,0,0,.8-2.58l-58.82-23L226.38,281Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71,346.5a1.79,1.79,0,0,0,.81,1.71,1.85,1.85,0,0,0,1.77-.2h0l45.76-26.42,10.45-66-58.81,89.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,269.4a5.57,5.57,0,0,1-1.52,1.7l-.1.06L110.31,348h0a1.85,1.85,0,0,1-1.77.2l63.64-101.6a10,10,0,0,1,12.52-3.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71,241.63l61.13,27a10,10,0,0,0,12.51-3.85L245.54,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71,241.63l61.55,23a10,10,0,0,0,11.88-3.9L245.54,162Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,320.81V218.93a10.94,10.94,0,0,1,1.75-5.43l63.39-88.27a10,10,0,0,1,10.44-3.9l59.61,14.17a25,25,0,0,1,5.52,2.2l2.93,1.69a5.77,5.77,0,0,1,2.59,4.5V245.77a5.79,5.79,0,0,1-2.59,4.5L207.79,327a5.75,5.75,0,0,1-5.19,0l-2.93-1.69A5.76,5.76,0,0,1,197.07,320.81Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,320.81V218.93a10.94,10.94,0,0,1,1.75-5.43l63.39-88.27a10,10,0,0,1,10.44-3.9l59.61,14.17a25,25,0,0,1,5.52,2.2l2.93,1.69a5.77,5.77,0,0,1,2.59,4.5V245.77a5.79,5.79,0,0,1-2.59,4.5L207.79,327a5.75,5.75,0,0,1-5.19,0l-2.93-1.69A5.76,5.76,0,0,1,197.07,320.81Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,169.69v130c0,1.65,1.17,2.33,2.6,1.5l124.79-72a5.73,5.73,0,0,0,2.6-4.5v-130c0-1.66-1.16-2.33-2.6-1.5L211.85,165.19A5.74,5.74,0,0,0,209.25,169.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.69,302.06a1.83,1.83,0,0,1-.92-.24,2.27,2.27,0,0,1-1-2.11v-130a6.23,6.23,0,0,1,2.85-4.94l124.79-72a2.07,2.07,0,0,1,3.35,1.94v130a6.2,6.2,0,0,1-2.85,4.93l-124.79,72A2.85,2.85,0,0,1,210.69,302.06ZM337.8,93.28a1.92,1.92,0,0,0-.91.29L212.1,165.62a5.28,5.28,0,0,0-2.35,4.07v130a1.11,1.11,0,0,0,1.85,1.07l124.79-72a5.27,5.27,0,0,0,2.35-4.07v-130a1.39,1.39,0,0,0-.51-1.25A.86.86,0,0,0,337.8,93.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,221.41l-9-5.2a9.52,9.52,0,0,0-.48,2.72V320.81a5.76,5.76,0,0,0,2.6,4.5L202.6,327a5.72,5.72,0,0,0,5.19,0l1.25-.71Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.56,221.41l-9-5.2a9.52,9.52,0,0,0-.48,2.72V320.81a5.76,5.76,0,0,0,2.6,4.5L202.6,327a5.72,5.72,0,0,0,5.19,0l1.25-.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M343.31,143.89V245.77a5.3,5.3,0,0,1-.81,2.63,5.57,5.57,0,0,1-1.52,1.7l-.1.06-.17.11L207.8,327h0a1.85,1.85,0,0,1-1.77.2,1.79,1.79,0,0,1-.81-1.71V223.62a2.26,2.26,0,0,1,2.92-2.3L264,234.61l7.32,1.74A4.82,4.82,0,0,0,276,234.6l8.48-11.81,57.08-79.47C342.52,142,343.31,142.23,343.31,143.89Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.31,143.89V245.77a5.3,5.3,0,0,1-.81,2.63,5.57,5.57,0,0,1-1.52,1.7l-.1.06-.17.11L207.8,327h0a1.85,1.85,0,0,1-1.77.2,1.79,1.79,0,0,1-.81-1.71V223.62a2.26,2.26,0,0,1,2.92-2.3L264,234.61l7.32,1.74A4.82,4.82,0,0,0,276,234.6l8.48-11.81,57.08-79.47C342.52,142,343.31,142.23,343.31,143.89Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.71,250.27l.17-.11.1-.06a5.57,5.57,0,0,0,1.52-1.7,5.32,5.32,0,0,0,.8-2.59l-58.82-23L323.87,260Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.2,325.5a1.79,1.79,0,0,0,.81,1.71,1.85,1.85,0,0,0,1.77-.2h0l45.76-26.42,10.45-66-58.81,89.2Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5,248.4a5.57,5.57,0,0,1-1.52,1.7l-.1.06L207.8,327h0a1.85,1.85,0,0,1-1.77.2l63.64-101.6a10,10,0,0,1,12.51-3.84Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5,248.4a5.57,5.57,0,0,1-1.52,1.7l-.1.06L207.8,327h0a1.85,1.85,0,0,1-1.77.2l63.64-101.6a10,10,0,0,1,12.51-3.84Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.2,199.63a7.28,7.28,0,0,1-6.41-2.2c-1.52-1.69-2.28-4.3-2.28-7.81A27.79,27.79,0,0,1,258,178.14a34.7,34.7,0,0,1,6.86-10A47.51,47.51,0,0,1,275.26,160q5.63-3.24,9.61-3.59c2.67-.24,4.68.45,6.06,2.05s2.06,4.05,2.06,7.33a19.17,19.17,0,0,1-2.24,9.34,15.58,15.58,0,0,1-5.92,6.26,4.36,4.36,0,0,1-3,.78,2,2,0,0,1-1.56-1.51,18.33,18.33,0,0,1-3.14,4.29,19.46,19.46,0,0,1-4.28,3.33c-2.72,1.54-4.89,2-6.49,1.47S264,187.6,264,184.9a16.87,16.87,0,0,1,3-9.49,24.1,24.1,0,0,1,8.16-7.48,15.23,15.23,0,0,1,4.39-1.76,6.71,6.71,0,0,1,3.51,0v10.53c0,.85.15,1.37.44,1.57s.77.1,1.45-.29a6.46,6.46,0,0,0,2.65-3.51,17.31,17.31,0,0,0,.95-6.07q0-3.94-1.72-5.73a5.36,5.36,0,0,0-4.71-1.44,18,18,0,0,0-6.87,2.56,33.62,33.62,0,0,0-11.15,10A22.89,22.89,0,0,0,260,187q0,4.31,1.77,6.29a5.46,5.46,0,0,0,4.88,1.68,17.79,17.79,0,0,0,7-2.57,28.62,28.62,0,0,0,4.15-2.92,22.13,22.13,0,0,0,3.27-3.34,1.76,1.76,0,0,1,.35-.34c.09-.05.18,0,.26.12l1.1,2a1.08,1.08,0,0,1,.09.25,1,1,0,0,1-.31.58,30.92,30.92,0,0,1-4,4,35.21,35.21,0,0,1-4.89,3.44A23.63,23.63,0,0,1,264.2,199.63Zm13-18.8a6.7,6.7,0,0,0,1.58-4v-6.1a8.62,8.62,0,0,0-4,1.38,13.79,13.79,0,0,0-4.74,4.41,10.19,10.19,0,0,0-1.75,5.67c0,1.69.42,2.7,1.27,3s2.16,0,3.95-1.07A12.62,12.62,0,0,0,277.24,180.83Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notifications--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.84,209.65,127.09,204h0l-.07,0h0c-3.33-1.88-7.92-1.6-13,1.33-10.21,5.89-18.48,20.22-18.48,32,0,5.89,2.06,10,5.39,12h0l9.07,5.19,1.64-2.73a19,19,0,0,0,5.3-2.06c10.2-5.9,18.48-20.23,18.48-32a20.06,20.06,0,0,0-.58-4.72Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.84,209.65,127.09,204h0l-.07,0h0c-3.33-1.88-7.92-1.6-13,1.33-10.21,5.89-18.48,20.22-18.48,32,0,5.89,2.06,10,5.39,12h0l9.07,5.19,1.64-2.73a19,19,0,0,0,5.3-2.06c10.2-5.9,18.48-20.23,18.48-32a20.06,20.06,0,0,0-.58-4.72Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.84,209.65,127.09,204h0l-.07,0h0c-3.33-1.88-7.92-1.6-13,1.33-10.21,5.89-18.48,20.22-18.48,32,0,5.89,2.06,10,5.39,12h0l9.07,5.19,1.64-2.73a19,19,0,0,0,5.3-2.06c10.2-5.9,18.48-20.23,18.48-32a20.06,20.06,0,0,0-.58-4.72Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.39,210.7c-10.21,5.9-18.48,20.23-18.48,32s8.27,16.56,18.48,10.67,18.48-20.22,18.48-32S133.6,204.81,123.39,210.7Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.17,245.52c-.19,0-.29-.11-.29-.28a1.54,1.54,0,0,1,.16-.54l.93-2.09a1.06,1.06,0,0,1,.35-.52,1.13,1.13,0,0,1,.44-.1,9,9,0,0,0,2.44-.49,15.58,15.58,0,0,0,3-1.38A12.15,12.15,0,0,0,127,236.9a5.91,5.91,0,0,0,1.23-3.49c0-2.21-1.35-2.53-4.05-1L121.55,234c-.43.24-.73.33-.91.25s-.27-.32-.27-.72v-.83a1.73,1.73,0,0,1,.27-1,2.69,2.69,0,0,1,.91-.78l2.61-1.51a7.14,7.14,0,0,0,2.58-2.39,5.37,5.37,0,0,0,.86-2.81q0-3.21-4.52-.6a19.62,19.62,0,0,0-4.94,4,3.15,3.15,0,0,1-.44.41.29.29,0,0,1-.35-.08l-.89-1a.5.5,0,0,1-.16-.36,1,1,0,0,1,.28-.61,19.16,19.16,0,0,1,3-3,30.28,30.28,0,0,1,4.11-2.82,12.9,12.9,0,0,1,4.25-1.69,3.35,3.35,0,0,1,2.77.55,3.31,3.31,0,0,1,1,2.67,8.17,8.17,0,0,1-.72,3.19,11.11,11.11,0,0,1-2,3.16,2.69,2.69,0,0,1,2.56.47,3.57,3.57,0,0,1,.85,2.62,10.49,10.49,0,0,1-2.22,6.1,19.55,19.55,0,0,1-6.28,5.46Q118.62,245.77,116.17,245.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.87,354.09h0l.19-.17c.14-.12.29-.24.42-.37l.45-.44.45-.43a10.47,10.47,0,0,0,.75-.78l3.56,2.66,2.37,1.77a0,0,0,0,1,0,0,11.57,11.57,0,0,0-2.08,3.17s-.71,1.15-3.12.57C325.88,359.38,325.41,355,325.87,354.09Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,352.87c-2.72-3.16-.3-8.41,2.34-15.22,2.9-7.49,7.38-20.22,7.38-20.22l31.81-6.57s33.89-.65,37,5.83c2.52,5.19-19.8,13-23,13.28L326.94,331l-2.06,1-13.76,17.41Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.61,322a80.06,80.06,0,0,0-6.89,8c-5.73,8-14.8,22.53-14.8,22.53s1.41,4.6,5.74,4.4c0,0,29.8-27.83,32.24-30.4,3.69-3.9,6.65-10.33.27-10.86S352.09,319.32,349.61,322Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.56,330.16s5.32-7.78,10.83-11c0,0-5.48,1.08-13.78,11.18Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.56,330.16s5.32-7.78,10.83-11c0,0-5.48,1.08-13.78,11.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.18,340l-2.09.4,1.94,7.17s1.88-.18,2.53-.14a10.67,10.67,0,0,0,2.71-1.05l-.5-4.38-2.3-2.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.68,341.69a7.82,7.82,0,0,1,4.38,4.46,22.42,22.42,0,0,1,1.09,3.24c.33,1.16.17,3.13-1.3,3.45a2.43,2.43,0,0,1-1.39-.25c-2.95-1.14-5.83-2.46-8.85-3.42a29.38,29.38,0,0,0-8.05-1.75,5.57,5.57,0,0,0-.24-6.41,3.88,3.88,0,0,0-2.14-1c.76-.34,1.47-.78,2.2-1.19a6.67,6.67,0,0,1,4.67-1.15c1.26.27,2.22,1.27,3.29,2C358.38,341,360.35,340.91,362.68,341.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.29,346c2.63-.81,6.83-1.53,19.29-2.17s29.51-3.44,29.51-3.44c2.9,2.79,1.94,7.17,1.94,7.17s-22.13,7-29.34,7.93c-11.48,1.48-15.44,1.37-20.62.26C290.25,354.5,286.58,348.67,295.29,346Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.83 286.65 350.19 309.02 343.49 313.14 330.61 291.33 340.83 286.65",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.47,265.57c5.12.06,10.75,1.92,12.69,5.93l8,16.5s-4.52,6.62-11.7,6.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.43,300.34c.06-.87,1.31-5.12,2.65-9.7L299.8,294l-2.61,8.23L289,310A12.88,12.88,0,0,1,287.43,300.34Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,265.88c-6.1,1.47-14.41,3.38-16.82,10s-5.86,18.31-5.86,18.31c1.34,2.32,8.69,4.24,11.24,2.9l1.2-4v24.32c4.77,5.19,28.3,3.86,31.81-6.57V277.71c0-5.3-2.94-11.67-11.07-12.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.73 293.11 303.79 283.48 300.73 297.42 300.73 293.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.68,238.77a3.63,3.63,0,0,0-3,1c-1.29,1.32-1,3.76,0,9.36l4,.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.89,237.15a6.2,6.2,0,0,0,2.49-.51c1.22-.7,1.54.69.87,1.89a5.69,5.69,0,0,1-4.62,3.08c0-.17-1.14-3.11-1.14-3.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.55,249.64c-.59.35-1.44-.78-2.17-1.55a2.56,2.56,0,0,0-4.29.7c-1.21,2.55,1.54,5.94,3.15,7.06a2.83,2.83,0,0,0,3.31.28l.42,9.75a10.39,10.39,0,0,0,7.84,5.95c5.72.77,4.54-3.95,2.66-6.26V262a13.72,13.72,0,0,0,4.36.22c.74-.2,2.52-2.35,3.67-4.76,1.29-2.7,3.44-7.5,1.53-15.63-2.06-8.72-11.43-9-17-5.47S310.55,249.64,310.55,249.64Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.55,250.63c-.3,0-1.43-1.87-2.17-2.54-1-.93.3-9.32.3-9.32s-1-3.19,1-5.3,5.92-1.76,8.78-1.86a25.7,25.7,0,0,0,10.2-2.05c4.06-1.76,4.36-2,4.86-.19s.7,5.86-1.72,8.59l-1.32,2.15s-1.23,1-5,1.5-10.23-1.57-11-1.68c-1.1-.15-1.33.91-1.92,3.81C312,246.29,311.55,250.61,310.55,250.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.69,239.42l-3.58-1.92a2,2,0,0,1,2.71-.89A2.14,2.14,0,0,1,308.69,239.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.46,262s-5.3-1.07-7.15-2a6.13,6.13,0,0,1-2.56-2.54,8.4,8.4,0,0,0,1.46,3c1.35,1.73,8.25,3,8.25,3Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.63,249.44a1.06,1.06,0,1,1-1.06-1.1A1.08,1.08,0,0,1,321.63,249.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.51,245.44l-2.28,1.25a1.38,1.38,0,0,1,.53-1.81A1.27,1.27,0,0,1,320.51,245.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,256.54l2.43.92a1.28,1.28,0,0,1-1.65.8A1.36,1.36,0,0,1,321,256.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.1,246.32l-2.07-1.6a1.26,1.26,0,0,1,1.8-.27A1.37,1.37,0,0,1,331.1,246.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.46,249.14a1.06,1.06,0,1,1-1.06-1.1A1.08,1.08,0,0,1,330.46,249.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.46 249.01 324.46 255.33 327.96 254.92 325.46 249.01",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.94,320.78l-21.55-12.44a1.25,1.25,0,0,0-1.24,0l-37.79,21.82L323.52,343Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.32 341.13 311.7 334.43 345.68 314.81 357.36 321.48 323.32 341.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.61 322.49 317.83 322.61 323.52 325.9 333.65 320.05 333.86 319.93 327.95 316.52 317.61 322.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.83 322.61 323.52 325.9 333.65 320.05 327.95 316.76 317.83 322.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.36,330.16v.51a2.09,2.09,0,0,0,1,1.8l20.08,11.59a2.07,2.07,0,0,0,2.08,0l36.34-21a2.1,2.1,0,0,0,1-1.8v-.51L323.52,343Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.52,343v1.38a2,2,0,0,0,1-.28l36.34-21a2.1,2.1,0,0,0,1-1.8v-.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.11,343.27a2.47,2.47,0,0,0,2.12-.17l36.18-20.89a2.43,2.43,0,0,0,1.19-1.72l4-23.61a2.85,2.85,0,0,0,0-.41,2.48,2.48,0,0,0-.73-1.75l-37.6,21.71a1.81,1.81,0,0,0-.88,1.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.52,343l.25.14a3.59,3.59,0,0,0,.34.17l4.28-25.57a1.81,1.81,0,0,1,.88-1.27l37.6-21.71a3.14,3.14,0,0,0-.5-.38L328.7,316.09a1.83,1.83,0,0,0-.89,1.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.48,321.46a8,8,0,0,1,3.65-4.69c1.75-1,2.95-.55,2.69,1a8,8,0,0,1-3.65,4.69C345.42,323.51,344.22,323,344.48,321.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.19,302.21s6.49,25,9.23,26.79,7.84,3.1,10.28,4,3.55,2.13,3.13,2.47-3.94.71-5.16,1.14.36,2.4,3.06,4.49,5,1.9,4.7,3.29-6.32,2.78-11.4-.2-6.62-7-9.65-10.41S291.43,316.2,289,310c0,0,.23-11.52,4-10.79S297.19,302.21,297.19,302.21Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.07,352.87c.46,1.11,2.05,4.17,5.59,4l8.7-8.14Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.07,352.87c.46,1.11,2.05,4.17,5.59,4l8.7-8.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.32,357.84a.49.49,0,0,1,0,.11A.49.49,0,0,0,333.32,357.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.7,367.19a20,20,0,0,1,1.27-7.68h0a3.18,3.18,0,0,1-2.91.38c-2.91-.87-3.64-4.93-3.18-5.81h0c-.42.37-.86.72-1.29,1.08a6.63,6.63,0,0,0-2.75,3.95c-.2,1.27.39,2.52.68,3.78.56,2.4,0,4.9-.09,7.36a7.85,7.85,0,0,0,2.59,5.68,21.31,21.31,0,0,0,2.64,2.19,2.48,2.48,0,0,0,4.33-1.77C331.61,373.23,330.88,370.44,330.7,367.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,356.35c-.27.51-.51,1-.72,1.49C333.53,357.36,333.77,356.86,334,356.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.86,354.08h0l.19-.17Z",
    style: {
      fill: "#37474f"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSent);
export default __webpack_public_path__ + "static/media/Mail-sent.b5ce7ead97e63520d8f9ea63bef2a2ea.svg";
export { ForwardRef as ReactComponent };